import React, { ReactNode } from 'react';
import useMe from '../../hooks/useMe';
import useSentry from '../../hooks/useSentry';
import { VgsCollectProvider } from '../../context/VgsCollect';

export default function VaultForm({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element {
  const me = useMe();
  useSentry(me?.id);

  return <VgsCollectProvider>{children}</VgsCollectProvider>;
}
